export class DataQualityTableMeta {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "pipeline",
            "baseName": "pipeline",
            "type": "string",
            "format": ""
        },
        {
            "name": "source",
            "baseName": "source",
            "type": "string",
            "format": ""
        },
        {
            "name": "partitionBy",
            "baseName": "partitionBy",
            "type": "string",
            "format": ""
        },
        {
            "name": "rowsPerSec",
            "baseName": "rowsPerSec",
            "type": "number",
            "format": "double"
        },
        {
            "name": "columnCount",
            "baseName": "columnCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "numericColumnCount",
            "baseName": "numericColumnCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "categoricalColumnCount",
            "baseName": "categoricalColumnCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "trackedColumnCount",
            "baseName": "trackedColumnCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "totalRecords",
            "baseName": "totalRecords",
            "type": "number",
            "format": "double"
        },
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "lastCommitMs",
            "baseName": "lastCommitMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "freshnessSeconds",
            "baseName": "freshnessSeconds",
            "type": "number",
            "format": "double"
        }
    ];
    static getAttributeTypeMap() {
        return DataQualityTableMeta.attributeTypeMap;
    }
    constructor() {
    }
}
